import { IntercomService } from './intercom.service';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashboardRoutes } from './dashboard.routes';
import { DashboardComponent } from './dashboard.component';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../layout/layout.module';

@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    RouterModule.forChild(DashboardRoutes),
    SharedModule,
    LayoutModule
  ],
  providers: [
    IntercomService
  ]
})
export class DashboardModule {

}
